import React from "react";
import Particles from "react-tsparticles";
import { useTheme, THEMES } from "../context/ThemeContext";

function Particle() {
  const { theme } = useTheme();

  let particleColor = "#c770f0";
  if (theme === THEMES.DARK) particleColor = "#38bdf8";
  else if (theme === THEMES.LIGHT) particleColor = "#0891b2";
  else if (theme === THEMES.CLAY) particleColor = "#a78bfa";

  return (
    <Particles
      id="tsparticles"
      params={{
        particles: {
          number: {
            value: 140,
            density: {
              enable: true,
              value_area: 1500,
            },
          },
          color: {
            value: particleColor,
          },
          line_linked: {
            enable: false,
            opacity: 0.03,
          },
          move: {
            direction: "right",
            speed: 0.05,
          },
          size: {
            value: 1.5,
          },
          opacity: {
            anim: {
              enable: true,
              speed: 1,
              opacity_min: 0.05,
            },
          },
        },
        interactivity: {
          events: {
            onclick: {
              enable: true,
              mode: "push",
            },
          },
          modes: {
            push: {
              particles_nb: 1,
            },
          },
        },
        retina_detect: true,
      }}
    />
  );
}

export default Particle;
